export default __webpack_public_path__ + "static/media/profile.93b4853e.jpeg";